<div class="p-4 flex flex-col">
  <div class="flex items-center justify-between">
    <h3 class="!m-0 !font-bold">Config Conflicts</h3>
    <button
      mat-stroked-button
      (click)="refresh()"
      [disabled]="loading()"
    >
      @if (loading()) {
        <mat-spinner class="mr-2 inline-block" diameter="18" />
      }
      <mat-icon>refresh</mat-icon>
      Refresh
    </button>
  </div>
  @if (loading()) {
    <div
      class="flex flex-col items-center justify-center px-4 py-8 text-black opacity-60"
    >
      <mat-spinner diameter="40" />
      <p class="mt-4 text-sm">Checking bridge device configurations...</p>
    </div>
  } @else if (error()) {
    <div
      class="flex flex-col items-center justify-center px-4 py-8 text-red-600"
    >
      <mat-icon class="mb-2 !h-10 !w-10 !text-[40px]">error_outline</mat-icon>
      <p class="m-0 text-sm">{{ error() }}</p>
    </div>
  } @else {
    @let reportData = report()!;

    <table mat-table [dataSource]="sortedSummaries()" class="w-full">
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="!w-16">Status</th>
        <td mat-cell *matCellDef="let summary">
          <mat-icon
            class="!text-xl"
            [ngClass]="{
              'text-green-600': summary.status === BridgeDeviceStatus.Active,
              'opacity-30': summary.status !== BridgeDeviceStatus.Active
            }"
            [matTooltip]="getStatusLabel(summary)"
            >{{ getStatusIcon(summary) }}</mat-icon
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Device</th>
        <td mat-cell *matCellDef="let summary">
          <div class="flex items-center gap-2 font-medium">
            {{ summary.deviceName }}
            @if (summary.deleted) {
              <span
                class="rounded bg-red-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase text-red-700"
                >Deleted</span
              >
            }
          </div>
          <div class="text-xs text-black opacity-50">{{ summary.deviceId }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="integrations">
        <th mat-header-cell *matHeaderCellDef>Enabled Integrations</th>
        <td mat-cell *matCellDef="let summary">
          @if (summary.enabledIntegrations.length) {
            <span class="text-sm">
              {{ summary.enabledIntegrations.join(', ') }}
            </span>
          } @else {
            <span class="text-sm opacity-30">None</span>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    @if (reportData.conflicts.length) {
      <div class="flex flex-col mt-4">
      <h3 class="!m-0 !font-bold text-red-700">
        {{ reportData.conflicts.length }} Path Conflict{{
          reportData.conflicts.length === 1 ? '' : 's'
        }}
        Found
      </h3>
      <mat-list class="!p-0">
        @for (conflict of reportData.conflicts; track conflict.normalisedPath) {
          <mat-list-item>
            <mat-icon matListItemIcon class="!text-red-600">warning</mat-icon>
            <span matListItemTitle>{{ conflict.normalisedPath }}</span>
            <span matListItemLine>
              @for (
                usage of conflict.usages;
                track usage.deviceId;
                let last = $last
              ) {
                {{ usage.deviceName }} ({{ usage.integrationName }}.{{
                  usage.fieldName
                }}){{ last ? '' : ', ' }}
              }
            </span>
          </mat-list-item>
        }
      </mat-list>
      </div>
    } @else {
      <div
        class="flex flex-col items-center justify-center px-4 py-8 text-black opacity-40"
      >
        <mat-icon
          fontSet="material-symbols-outlined"
          class="mb-4 !h-12 !w-12 !text-5xl"
          >check_circle</mat-icon
        >
        <p class="m-0 text-sm">No path conflicts found.</p>
      </div>
    }
  }
</div>
